export default __webpack_public_path__ + "static/media/katana both.e6049f09.png";